import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import WhatsAppFloat from '../components/WhatsAppFloat';

const SocialMedia = () => {
    useEffect(() => {
        // Force hide spinner immediately
        const spinner = document.getElementById('spinner');
        if (spinner) {
            spinner.classList.remove('show');
            spinner.style.display = 'none';
            spinner.style.opacity = '0';
            spinner.style.visibility = 'hidden';
        }
        if (window.WOW) {
            new window.WOW().init();
        }
    }, []);

    return (
        <>
            <WhatsAppFloat />
            <Navbar />

            {/* Page Header Start */}
            <div className="container-fluid page-header mb-5 wow fadeIn" data-wow-delay="0.1s">
                <div className="container">
                    <h1 className="display-3 mb-4 animated slideInDown">Social Media Presence</h1>
                    <nav aria-label="breadcrumb animated slideInDown">
                        <ol className="breadcrumb mb-0">
                            <li className="breadcrumb-item"><a href="/">Home</a></li>
                            <li className="breadcrumb-item"><a href="/service">Services</a></li>
                            <li className="breadcrumb-item active" aria-current="page">Social Media Presence</li>
                        </ol>
                    </nav>
                </div>
            </div>
            {/* Page Header End */}

            {/* Social Media Presence Start */}
            <div className="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
                <div className="container">
                    <div className="row g-5 align-items-center">
                        <div className="col-lg-6">
                            <h1 className="mb-4">Boost Your Brand with Our Social Media Presence Services</h1>
                            <p>In today's digital age, having a strong social media presence is crucial for any business. At WebBears, we specialize in crafting comprehensive social media strategies that help you connect with your audience, build brand awareness, and drive engagement.</p>
                            <ul>
                                <li><i className="fa fa-check text-primary me-2"></i><strong>Strategy Development:</strong> Tailored social media strategies that align with your business goals.</li>
                                <li><i className="fa fa-check text-primary me-2"></i><strong>Content Creation:</strong> Engaging and high-quality content to captivate your audience.</li>
                                <li><i className="fa fa-check text-primary me-2"></i><strong>Account Management:</strong> Professional management of your social media accounts.</li>
                                <li><i className="fa fa-check text-primary me-2"></i><strong>Analytics and Reporting:</strong> In-depth analysis and reporting to track your social media performance.</li>
                                <li><i className="fa fa-check text-primary me-2"></i><strong>Advertising Campaigns:</strong> Targeted social media advertising campaigns to maximize your reach.</li>
                            </ul>
                            <a className="btn btn-primary py-3 px-5" href="/contact">Contact Us</a>
                        </div>
                        <div className="col-lg-6">
                            <img className="img-fluid rounded wow zoomIn" data-wow-delay="0.5s" src="img/images/social-media.png" alt="Social Media Presence" />
                        </div>
                    </div>
                </div>
            </div>
            {/* Social Media Presence End */}

            <Footer />
        </>
    );
};

export default SocialMedia;
